module.exports = "<!-- <div class=\"spinner\">\r\n    Loading .....\r\n    <!-- <div class=\"bounce1\"></div>\r\n    <div class=\"bounce2\"></div>\r\n    <div class=\"bounce3\"></div> x\r\n</div> -->\r\n<div class=\"spinner-1\">\r\n    <h5 *ngIf = \"!!!this.largeFile; else elseBlock\" >Loading ...</h5>\r\n    <ng-template #elseBlock><h5 style=\"margin-left: -190px;\">This may take awhile due to the file size...</h5>\r\n    </ng-template>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modules/spinner/spinner.component.html
// module id = ./src/app/shared/modules/spinner/spinner.component.html
// module chunks = main